import React, { useEffect, useState } from "react";
import { FaBars, FaBell, FaSearch, FaUserCircle } from "react-icons/fa";
import "./Header.css";

const Header = () => {
  const [userName, setUserName] = useState("Admin");
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("tenant_user");

      if (storedUser) {
        const userData = JSON.parse(storedUser);

        setUserName(userData?.full_name || "");
        setUserRole(userData?.role || ""); // ✅ EXACT role from localStorage

        document.title = `${userData?.full_name} (${userData?.role})`;
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  return (
    <header className="ta-header">
      <div className="ta-header-left">
       
        <div className="ta-search-box">
          <FaSearch className="ta-search-icon" />
          <input 
            type="text" 
            placeholder="Search..." 
            className="ta-search-input" 
          />
        </div>
      </div>

      <div className="ta-header-right">
        <div className="ta-notification-wrapper">
          <button className="ta-notification-btn">
            <FaBell />
            <span className="ta-badge">3</span>
          </button>
        </div>
        
        <div className="ta-user-profile">
          <FaUserCircle className="ta-user-icon" />
          <div className="ta-user-info">
            <span className="ta-user-name">{userName}</span>
            {/* <small className="ta-user-role">{userRole}</small> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;